import { Eye, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useImpersonation, getProfileDisplayName } from '@/contexts/ImpersonationContext';

export const ImpersonationBadge = () => {
  const { isImpersonating, viewAs, resetView } = useImpersonation();

  if (!isImpersonating) return null;

  return (
    <div className="fixed top-20 left-1/2 -translate-x-1/2 z-50 bg-amber-500 text-amber-950 px-4 py-2 rounded-full shadow-lg flex items-center gap-3 animate-fade-in">
      <Eye className="w-4 h-4" />
      <span className="text-sm font-medium">
        Visualizando como: <strong>{getProfileDisplayName(viewAs)}</strong>
      </span>
      <Button
        variant="ghost"
        size="sm"
        onClick={resetView}
        className="h-6 px-2 text-amber-950 hover:bg-amber-600 hover:text-amber-950"
      >
        <X className="w-3 h-3 mr-1" />
        Voltar
      </Button>
    </div>
  );
};
